import "./Header.css";
import React, { useState, useEffect } from "react";
import logo from "../../images/logo.png";
import { LanguageSelector } from "../../helpers/LanguageSelector";
import { useTranslation } from "react-i18next";

export const Header = () => {
    const { t } = useTranslation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
            setMenuOpen(false);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        setMenuOpen(false);
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        const path = id === 'hero' ? '/' : `/${id}`;
        window.history.pushState({ section: id }, '', path);
    };

    useEffect(() => {
        const onPopState = (e) => {
            const id = e.state?.section || 'hero';
            document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const navItems = [
        { id: 'hero',      label: t("linkHome") },
        { id: 'about',     label: t("linkAbout") },
        { id: 'transport', label: t("linkTransport") },
        { id: 'stancane',  label: t("linkStancane") },
        { id: 'shelf',     label: t("linkShelf") },
        { id: 'contact',   label: t("linkContact") },
    ];

    return (
        <>
            <header className={`site-header ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
                <div className="header-inner">
                    <button className="header-logo" onClick={() => scrollToSection('hero')}>
                        <img src={logo} alt="Fibox" />
                    </button>

                    <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
                        {navItems.map((item) => (
                            <button
                                key={item.id}
                                className="nav-link-scroll"
                                onClick={() => scrollToSection(item.id)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </nav>

                    <div className="header-actions">
                        <LanguageSelector />
                        <button
                            className={`hamburger ${menuOpen ? 'active' : ''}`}
                            onClick={() => setMenuOpen(!menuOpen)}
                            aria-label="Menu"
                        >
                            <span />
                            <span />
                            <span />
                        </button>
                    </div>
                </div>
            </header>

            {menuOpen && <div className="nav-overlay" onClick={() => setMenuOpen(false)} />}
        </>
    );
};
